import React, { Component } from "react";
import { withNavigation } from "../withNavigation";
import "../styles/adminmatches.css";

class AdminMatches extends Component {

    constructor(props) {
        super(props);

        this.state = {
            totalMatches: 0,
            liveMatches: 0,
            livePlayers: []
        };
    }


    componentDidMount() {
        const admin =
            localStorage.getItem("adminToken");

        if (!admin) {
            this.props.navigate("/admin", {
                replace: true
            });
            return;
        }

        this.loadData();
        this.timer = setInterval(() => {
            this.loadData();
        }, 2000);

    }


    loadData = () => {
        fetch("https://api.hi-bigame.online/admin/matches")
            .then((res) => res.json())
            .then((data) => {
                this.setState({ totalMatches: data.totalMatches || 0 });
            });

        this.getLiveMatches();

        fetch("https://api.hi-bigame.online/admin/live-players")

            .then((res) => res.json())
            .then((data) => {
                this.setState({ livePlayers: data });
            });
    }


    getLiveMatches = () => {
        fetch("https://api.hi-bigame.online/admin/live-matches")
            .then((res) => res.json())
            .then((data) => {
                this.setState({ liveMatches: data.liveMatches || 0 });
            });
    };


    componentWillUnmount() {
        clearInterval(this.timer);
    }


    render() {
        return (
            <div>

                <div className="admin-matches-container">

                    <h1 className="admin-matches-title">🎮 Admin Matches</h1>

                    <div className="stats-box">
                        <h2>Total Matches: {this.state.totalMatches}</h2>
                        <h2>Live Matches: {this.state.liveMatches}</h2>
                    </div>

                    <div className="live-box">
                        <h2 className="live-title">🔴 Live Rooms</h2>

                        {this.state.livePlayers.length === 0 ? (<p className="no-live">No Live Games</p>) :
                            (this.state.livePlayers.map((g, i) => (
                                <div key={i} className="live-card">
                                    <p><strong>{g.player1}</strong> vs <strong>{g.player2}</strong></p>
                                    <p>₹{g.amount}</p>
                                    <p className="time">{new Date(g.startTime).toLocaleTimeString()} </p>
                                </div>
                            )))}
                    </div>

                    <h2 className="completed">  Completed Matches: {this.state.totalMatches - this.state.liveMatches}</h2>

                    <button className="admin-matches-back" onClick={() => this.props.navigate("/admin-dashboard")}>   Back</button>

                </div>
            </div>
        );
    }
}

export default withNavigation(AdminMatches);